import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  sectionFooter: {
    backgroundColor: theme.palette.background.dark,
    padding: '20px 0',
    backgroundImage: 'url("assets/images/tree.svg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '118px 143px',
    backgroundPosition: 'bottom center',
    [theme.breakpoints.down('sm')]: {
      backgroundSize: '75px 90px',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '35px 0',
    '@media(max-width: 684px)': {
      display: 'block',
      padding: '50px 0 100px 0',
    },
  },
  footerLogo: {
    width: 272,
    height: 'auto',
    '@media(max-width: 684px)': {
      margin: '0 auto',
      paddingBottom: 10,
    },
  },
  footerQlikLogo: {
    width: 212,
    height: 'auto',
    '@media(max-width: 684px)': {
      margin: '0 auto',
      paddingBottom: 4,
    },
  },
  caj: {
    display: 'flex',
    alignItems: 'center',
  },
  qlikCopy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    '@media(max-width: 684px)': {
      alignItems: 'center',
    },
  },
  copy: {
    marginTop: 5,
    color: '#707070',
    fontSize: '0.6125em',
  },
}));

export default useStyles;
